import { Box, Button, Image, Input, Text, Checkbox, useMediaQuery } from "@chakra-ui/react";
import { theme } from "../../styles/theme";
import logo from '../../assets/images/logo-white-orange.webp';
import greenLogo from '../../assets/images/logo-white-bg.webp';

import { useState, useEffect, useContext } from "react";
import { useAuth } from "../../Hooks/useAuth";
import { Link } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import { api } from "../../services/api";
import swal  from 'sweetalert';
import { FaHome } from "react-icons/fa";
import { CartContext } from "../../Context/CartContext";


export const userToken = () => window.localStorage.getItem("@app/token");
export function SignIn() {
  const { signInUser, getUserInfo   } = useAuth();
  const [userId, setUserId] = useState("");
  const isAuthenticated = () => userToken() !== null;
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const { handleCreateCart } = useContext(CartContext)
  // const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isMobile = useMediaQuery("(max-width: 767px)")[0];

  function handleUserLogin(e) {
    e.preventDefault();
    signInUser(userEmail, userPassword, userId)
  }

  function handleTogglePasswordVisibility(e) {
    e.preventDefault();
    const passwordInput = document.getElementById('password-input')
    if (e.target.checked) {
      passwordInput.type = "text"
    } else {
      passwordInput.type = "password"
    }
  }

  async function handleCallbackResponse(response) {
    let userObject = jwtDecode(response.credential);
    localStorage.setItem('userPhoto', userObject.picture);
    signInUserWithGoogleEmail(response.credential)
  }

  async function signInUserWithGoogleEmail(token) {
    const response = await api.get(`/api/v1/users/sign_in_with_google?id_token=${token}`);
    if (response.status === 200) {
      window.localStorage.setItem("@app/token", response.data.tokens["access-token"]);
      window.localStorage.setItem("@app/uid", response.data.tokens["uid"]);
      window.localStorage.setItem("@app/client", response.data.tokens["client"]);
      window.localStorage.setItem("@app/expiry", response.data.tokens["expiry"]);
      await getUserInfo(response.data.user);
      window.location.href = "/carrinho";
      if (typeof window !== "undefined") {
        if (window.fbq != null) {
          window.fbq('trackCustom', 'signInUserWithGoogleEmail');
        }
      }
    } else {
      swal({
        title: "Ops",
        text: "Ocorreu um erro no seu login, confira seus dados",
        icon: "error",
      });
    }
  }

  // useEffect(() => {
  //   /* global google */
  //   google.accounts.id.initialize({
  //     client_id: "480318445952-v2iilvljfmm9jk2l9c1ldi66fkjfh06f.apps.googleusercontent.com",
  //     callback: handleCallbackResponse
  //   });

  //   google.accounts.id.renderButton(
  //     document.getElementById("signInDiv"),
  //     {theme: "outline", size: "large"}
  //   )
  // }, []);

  useEffect(() => {
    const initializeGoogle = () => {
      if (!window.google || !window.google.accounts) {
        console.log("Google ainda não carregou...");
        return;
      }

      window.google.accounts.id.initialize({
        client_id: "480318445952-v2iilvljfmm9jk2l9c1ldi66fkjfh06f.apps.googleusercontent.com",
        callback: handleCallbackResponse
      });

      window.google.accounts.id.renderButton(
        document.getElementById("signInDiv"),
        { theme: "outline", size: "large" }
      );
    };

    // Aguarda até o script estar disponível
    const interval = setInterval(() => {
      if (window.google) {
        clearInterval(interval);
        initializeGoogle();
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

 return (
  <Box
    minH="100vh"
    bg="#f8f8f8"
    display="flex"
    alignItems="center"
    justifyContent="center"
    p={{ base: 4, md: 8 }}
    position="relative"
  >
    <Link
      to="/"
      style={{
        position: "absolute",
        top: "24px",
        right: "24px",
        zIndex: 10
      }}
    >
      <Box
        bg="white"
        p="12px"
        borderRadius="full"
        boxShadow="0 4px 20px rgba(0,0,0,.08)"
        transition="all .2s"
        _hover={{
          transform: "translateY(-2px)"
        }}
      >
        <FaHome color="#004a33" />
      </Box>
    </Link>

    <Box
      maxW="1200px"
      w="100%"
      bg="white"
      borderRadius="24px"
      overflow="hidden"
      boxShadow="0 12px 40px rgba(0,0,0,.08)"
    >
      <Box
        display="flex"
        flexDirection={{ base: "column", lg: "row" }}
      >

        {/* LADO ESQUERDO */}
        <Box
          flex="1"
          bg="linear-gradient(135deg,#004a33,#006b4b)"
          color="white"
          p={{ md: 12 }}
          display={{ base: "none", lg: "flex" }}
          flexDirection="column"
          justifyContent="center"
        >
          <Image
            src={isMobile ? greenLogo : logo}
            maxW="220px"
            mb="10"
            objectFit="contain"
          />

          <Text
            fontSize="48px"
            fontWeight="900"
            lineHeight="1.1"
          >
            Marketplace
            <br />
            Oficial Zen
          </Text>

          <Text
            mt="6"
            opacity=".9"
            fontSize="18px"
            maxW="500px"
          >
            Descubra bebidas selecionadas,
            kits exclusivos e experiências únicas,
            com entrega rápida e compra segura.
          </Text>

          <Box mt="10">
            <Text mb="3">
              ✓ Entrega Programada
            </Text>

            <Text mb="3">
              ✓ Compra 100% Segura
            </Text>

            <Text mb="3">
              ✓ Nota Fiscal
            </Text>

            <Text>
              ✓ Atendimento Humanizado
            </Text>
          </Box>
        </Box>

        {/* LADO DIREITO */}
        <Box
          flex="1"
          p={{ base: 6, md: 12 }}
          display="flex"
          flexDirection="column"
          justifyContent="center"
        >
          <Image
            src={greenLogo}
            maxW="180px"
            mx="auto"
            mb="8"
            display={{ base: "block", lg: "none" }}
          />

          <Text
            fontSize={{ base: "32px", md: "40px" }}
            fontWeight="900"
            color="#004a33"
          >
            Entrar
          </Text>

          <Text
            color="gray.500"
            mt="2"
            mb="8"
          >
            Acesse sua conta para continuar.
          </Text>

          <form onSubmit={(e) => handleUserLogin(e)}>
            <Input
              placeholder="Seu e-mail"
              h="56px"
              mb="4"
              borderRadius="14px"
              borderColor="#E2E8F0"
              onChange={(e) => setUserEmail(e.target.value)}
              autoComplete="current-email"
              _focus={{
                borderColor: "#fc8f04",
                boxShadow: "0 0 0 1px #fc8f04"
              }}
            />

            <Input
              id="password-input"
              placeholder="Sua senha"
              type="password"
              h="56px"
              borderRadius="14px"
              borderColor="#E2E8F0"
              onChange={(e) => setUserPassword(e.target.value)}
              autoComplete="current-password"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleUserLogin(e);
                }
              }}
              _focus={{
                borderColor: "#fc8f04",
                boxShadow: "0 0 0 1px #fc8f04"
              }}
            />

            <Checkbox
              mt="4"
              colorScheme="green"
              onChange={(e) => handleTogglePasswordVisibility(e)}
            >
              Mostrar senha
            </Checkbox>

            <Button
              mt="6"
              w="100%"
              h="56px"
              bg="#fc8f04"
              color="white"
              borderRadius="14px"
              fontWeight="700"
              type="submit"
              _hover={{
                bg: "#ea8100"
              }}
              onClick={(e) => handleUserLogin(e)}
            >
              Entrar
            </Button>
          </form>

          <Box
            my="8"
            display="flex"
            justifyContent="center"
          >
            <div id="signInDiv"></div>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            flexWrap="wrap"
            gap="4"
          >
            <Link
              to="/sign_up"
              style={{ textDecoration: "none" }}
            >
              <Text
                color="#fc8f04"
                fontWeight="600"
                _hover={{
                  textDecoration: "underline"
                }}
              >
                Criar Conta
              </Text>
            </Link>

            <Link
              to="/recuperar_senha"
              style={{ textDecoration: "none" }}
            >
              <Text
                color="#fc8f04"
                fontWeight="600"
                _hover={{
                  textDecoration: "underline"
                }}
              >
                Esqueceu sua senha?
              </Text>
            </Link>
          </Box>

          <Box
            mt="10"
            pt="6"
            borderTop="1px solid"
            borderColor="gray.100"
          >
            <Text
              fontSize="13px"
              color="gray.500"
              textAlign="center"
            >
              Ao acessar sua conta você concorda com os
              termos de uso e política de privacidade.
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  </Box>
);
}
